module.exports = __webpack_public_path__ + "static/media/active-future.ed32abad.svg";